var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"grid","place-items":"center"}},[_c('p',[_vm._v("Sorry, this page required a secure connection. Please open the page with HTTPS.")])])
}]

export { render, staticRenderFns }